import $ from 'jquery'

// Initializes buttons to open favorites.
// Dependencies are loosely coupled via a Backbone.Radio channel,
// and nothing is loaded until the button is clicked.
$('.favorites-open').on('click', async function (e) {
  e.preventDefault()
  const { default: channel } = await import(
    /* webpackChunkName: '@/favorites/channel' */ '@/favorites/channel'
  )
  await import(/* webpackChunkName: '@/favorites/app' */ '@/favorites/app')

  channel.request('favorites:open')
})
